// frontend/src/components/QuestionInput.jsx
import React, { useState } from 'react';

const QuestionInput = ({ onSend, isLoading }) => {
  const [question, setQuestion] = useState('');
  const [tonePreference, setTonePreference] = useState('casual');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (question.trim() && !isLoading) {
      onSend(question, tonePreference);
      setQuestion('');
    }
  };
  
  const toneOptions = [
    { value: 'casual', label: 'Casual & Friendly', emoji: '😊' },
    { value: 'formal', label: 'Professional', emoji: '🎓' },
    { value: 'slang', label: 'Teen-Friendly', emoji: '🤙' }
  ];

  return (
    <div className="space-y-3">
      {/* Tone Selection */}
      <div className="flex items-center justify-center space-x-4">
        <span className="text-sm font-medium text-gray-700">Response style:</span>
        <div className="flex space-x-2">
          {toneOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => setTonePreference(option.value)}
              className={`px-3 py-1 text-xs rounded-full border transition-colors ${
                tonePreference === option.value
                  ? 'bg-indigo-100 border-indigo-300 text-indigo-800'
                  : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100'
              }`}
              disabled={isLoading}
            >
              <span className="mr-1">{option.emoji}</span>
              {option.label}
            </button>
          ))}
        </div>
      </div>
      
      {/* Question Input */}
      <form onSubmit={handleSubmit} className="flex">
        <input
        type="text"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        placeholder="Ask a question about relationships..."
        className="flex-1 py-2 px-4 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        disabled={isLoading}
      />
      <button
        type="submit"
        className={`py-2 px-4 rounded-r-lg text-white ${
          isLoading
            ? 'bg-indigo-400 cursor-not-allowed'
            : 'bg-indigo-600 hover:bg-indigo-700'
        }`}
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="flex items-center">
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Sending...
          </span>
        ) : (
          'Send'
        )}
      </button>
    </form>
    </div>
  );
};

export default QuestionInput;